var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFleetsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.864 8.182h-6.137V0H4.091A4.09 4.09 0 0 0 0 4.09v22.5h4.09a6.141 6.141 0 0 0 6.137 6.137 6.141 6.141 0 0 0 6.137-6.136h12.272a6.141 6.141 0 0 0 6.137 6.136 6.141 6.141 0 0 0 6.136-6.136H45V16.364l-6.136-8.182ZM10.227 29.659a3.064 3.064 0 0 1-3.068-3.068 3.064 3.064 0 0 1 3.068-3.068 3.064 3.064 0 0 1 3.069 3.068 3.064 3.064 0 0 1-3.069 3.068Zm24.546 0a3.064 3.064 0 0 1-3.069-3.068 3.064 3.064 0 0 1 3.069-3.068 3.064 3.064 0 0 1 3.068 3.068 3.064 3.064 0 0 1-3.068 3.068Zm-2.046-13.295V11.25h5.114l4.02 5.114h-9.134Z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D253C",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M38.864 8.182h-6.137V0H4.091A4.09 4.09 0 0 0 0 4.09v22.5h4.09a6.141 6.141 0 0 0 6.137 6.137 6.141 6.141 0 0 0 6.137-6.136h12.272a6.141 6.141 0 0 0 6.137 6.136 6.141 6.141 0 0 0 6.136-6.136H45V16.364l-6.136-8.182ZM10.227 29.659a3.064 3.064 0 0 1-3.068-3.068 3.064 3.064 0 0 1 3.068-3.068 3.064 3.064 0 0 1 3.069 3.068 3.064 3.064 0 0 1-3.069 3.068Zm24.546 0a3.064 3.064 0 0 1-3.069-3.068 3.064 3.064 0 0 1 3.069-3.068 3.064 3.064 0 0 1 3.068 3.068 3.064 3.064 0 0 1-3.068 3.068Zm-2.046-13.295V11.25h5.114l4.02 5.114h-9.134Z",
    mask: "url(#b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1440v900H0z",
    transform: "translate(-38 -543)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetsIcon);
export default __webpack_public_path__ + "static/media/fleets-icon.a9aac1a757fc43a72f081d1b1e1057b5.svg";
export { ForwardRef as ReactComponent };